// ** React Imports
import { useMemo } from "react";

// ** Custom Components
import MenuList from "components/layout/Menu/List";
import MenuItem from "components/layout/Menu/Item";

// ** Utils & Helpers
import slug from "utils/slug";
import MenuItemContent from "./MenuItemContent";

// #####################################################

const MenuItems = ({
	withSearchInput,
	searchValue,
	finalItems,
	selected,
	handleSelectItem,
	menuFontSize,
	multiple,
	allwaysSelected,
	withAdditionalInfo,
	alwaysLight,
	customInput,
}) => {
	// ** Lista elementów menu z uwzględnieniem filtra z pola szukaj
	const filteredItems = useMemo(() => {
		return withSearchInput && searchValue.length > 0
			? finalItems.filter((item) => {
					if (item?.searchContent) {
						return (
							!item.empty &&
							slug(item.searchContent, " ")
								.toLowerCase()
								.match(
									new RegExp(
										`^${slug(
											searchValue.toLowerCase(),
											" "
										)}`
									)
								)
						);
					}
					return (
						!item.empty &&
						slug(item.content, " ")
							.toLowerCase()
							.match(
								new RegExp(
									`^${slug(searchValue.toLowerCase(), " ")}`
								)
							)
					);
			  })
			: finalItems;
	}, [withSearchInput, searchValue, finalItems]);

	// #####################################################

	return (
		<MenuList customInput={customInput} isSelector>
			{filteredItems.map((item) => {
				return (
					<MenuItem
						tabIndex={0}
						cliclable
						checked={true}
						onClick={() => handleSelectItem(item)}
						allwaysSelected={allwaysSelected}
						key={item.key}
						alwaysLight={alwaysLight}
					>
						<MenuItemContent
							item={item}
							selected={selected}
							alwaysLight={alwaysLight}
							menuFontSize={menuFontSize}
							isMultiple={multiple}
							customInput={customInput}
							withAdditionalInfo={withAdditionalInfo}
						/>
					</MenuItem>
				);
			})}
		</MenuList>
	);
};

export default MenuItems;

// #####################################################
